import { useState } from "react";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { CheckCircle, Shield } from "lucide-react";

export default function LegalAgreementPage({ onAccept }) {
  const [accepted, setAccepted] = useState(false);

  const handleAccept = () => {
    if (accepted) {
      localStorage.setItem("legal_agreement_accepted", "true");
      localStorage.setItem("legal_agreement_date", new Date().toISOString());
      onAccept();
    }
  };

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4"
      dir="rtl"
    >
      <Card className="bg-slate-900/80 backdrop-blur border-slate-700 max-w-md w-full">
        <CardContent className="p-6">
          {/* Header */}
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-emerald-600 mb-4">
              <Shield className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-xl font-bold text-white mb-2">
              مرحباً بك في التطبيق
            </h1>
            <p className="text-slate-400 text-sm">
              تطبيق إدارة المحلات التجارية
            </p>
          </div>

          {/* Simple Terms */}
          <div className="bg-slate-800/50 rounded-xl p-4 mb-6 text-slate-300 text-sm space-y-3">
            <p>• هذا التطبيق مصمم لمساعدتك في إدارة محلك التجاري</p>
            <p>• بياناتك محفوظة بشكل آمن على السيرفرات</p>
            <p>• أنت المسؤول عن دقة البيانات التي تدخلها</p>
            <p>• للتواصل والدعم: تواصل مع مزود الخدمة</p>
          </div>

          {/* Checkbox */}
          <label className="flex items-start gap-3 p-4 rounded-xl bg-slate-800/30 border border-slate-700 cursor-pointer hover:bg-slate-800/50 transition-colors mb-6">
            <input
              type="checkbox"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              className="mt-1 w-5 h-5 rounded border-slate-600 bg-slate-900 text-emerald-500 focus:ring-emerald-500"
            />
            <span className="text-slate-300 text-sm">
              أوافق على استخدام التطبيق وفهمت أن بياناتي ستُحفظ لتقديم الخدمة
            </span>
          </label>

          {/* Accept Button */}
          <Button
            onClick={handleAccept}
            disabled={!accepted}
            className={`w-full py-6 text-lg font-bold transition-all ${
              accepted
                ? "bg-gradient-to-r from-emerald-600 to-emerald-500 hover:from-emerald-700 hover:to-emerald-600"
                : "bg-slate-700 text-slate-500 cursor-not-allowed"
            }`}
          >
            {accepted ? (
              <>
                <CheckCircle className="w-5 h-5 me-2" />
                متابعة
              </>
            ) : (
              "يرجى الموافقة للمتابعة"
            )}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
